import {
	Box,
	IconButton,
	Link,
	Table,
	TableBody,
	TableCell,
	TableContainer,
	TableHead,
	TableRow,
	TextField,
	Typography,
} from "@mui/material";
import React from "react";
import { ASSETS_BASE_URL } from "../../config";
import { useNavigate } from "react-router-dom";
import { Add as AddIcon, Remove as RemoveIcon, DeleteOutline as DeleteIcon } from "@mui/icons-material";
import { TABLE_HEADERS, UI_TEXT } from "../../constants";
import { useTranslation } from "react-i18next";

const QuantityTable = ({ data, setData }) => {
	const defaultImage = `${ASSETS_BASE_URL}/stock.png`;
	const navigate = useNavigate();
	const {t} = useTranslation();

	const handleError = (e) => {
		e.target.onerror = null; // Prevent infinite loop
		e.target.src = defaultImage;
	};
	const handleNavigateToProduct = (url) => {
		navigate(url);
	};

	const handleUpdateQuantity = (productId, change) => {
		setData((prevData) =>
			prevData.map((item) =>
				item.product_id === productId
					? {
							...item,
							quantity: Math.max(1, Math.min(99, item.quantity + change)),
					  }
					: item
			)
		);
	};

	const handleQuantityChange = (productId, newValue) => {
		const numericValue = parseInt(newValue);
		if (!isNaN(numericValue)) {
			setData((prevData) =>
				prevData.map((item) => (item.product_id === productId ? { ...item, quantity: numericValue } : item))
			);
		}
	};

	const handleBlur = (productId) => {
		setData((prevData) =>
			prevData.map((item) =>
				item.product_id === productId
					? {
							...item,
							quantity: Math.max(1, Math.min(99, parseInt(item.quantity) || 1)),
					  }
					: item
			)
		);
	};

	const handleRemoveItem = (productId) => {
		setData((prevData) => prevData.filter((item) => item.product_id !== productId));
	};

	return (
		<Box sx={{ my: 1, mx: 4, width: "90%" }}>
			<TableContainer>
				<Table>
					<TableHead>
						<TableRow>
							<TableCell>{t('TABLE_HEADERS.PARTS_QUANTITY')}</TableCell>
							<TableCell align="center">{t('TABLE_HEADERS.QUANTITY')}</TableCell>
							<TableCell>{t('TABLE_HEADERS.ACTIONS')}</TableCell>
						</TableRow>
					</TableHead>
					<TableBody>
						{data.map((item) => {
							const src = `${ASSETS_BASE_URL}/ProductImages/TMB/${item.product_number}.png`;

							return (
								<TableRow
									key={item.product_id}
									sx={{ "&:last-child td, &:last-child th": { border: 0 } }}>
									<TableCell>
										<Box
											sx={{
												display: "flex",
												alignItems: "center",
												gap: "8px",
												justifyContent: "flex-start",
											}}>
											<img
												src={src}
												alt={item.product_name}
												onError={handleError}
												style={{
													width: "40px",
													height: "40px",
													objectFit: "cover",
													borderRadius: "4px",
												}}
											/>
											<Box>
												<Link
													underline="hover"
													sx={{ cursor: "pointer" }}
													onClick={() => {
														const url = `/machines/${item.machine_id}/${item.product_id}`;
														handleNavigateToProduct(url);
													}}>
													{item.product_name}
												</Link>
												<Typography variant="body2" color="textSecondary">
													{t('UI_TEXT.PART')} {item.product_number}
												</Typography>
											</Box>
										</Box>
									</TableCell>
									<TableCell align="center">
										<Box className="quantity-controls">
											<IconButton
												size="small"
												onClick={() => handleUpdateQuantity(item.product_id, -1)}>
												<RemoveIcon />
											</IconButton>
											<TextField
												type="number"
												size="small"
												value={item.quantity}
												onChange={(e) => handleQuantityChange(item.product_id, e.target.value)}
												onBlur={() => handleBlur(item.product_id)}
												className="quantity-input"
												InputProps={{
													inputProps: {
														min: 1,
														max: 99,
													},
												}}
												sx={{
													"& input[type=number]::-webkit-outer-spin-button, & input[type=number]::-webkit-inner-spin-button":
														{
															"-webkit-appearance": "none",
															margin: 0,
														},
													"& input[type=number]": {
														"-moz-appearance": "textfield",
													},
												}}
											/>
											<IconButton
												size="small"
												onClick={() => handleUpdateQuantity(item.product_id, 1)}>
												<AddIcon />
											</IconButton>
										</Box>
									</TableCell>
									<TableCell>
										<IconButton color="primary" onClick={() => handleRemoveItem(item.product_id)}>
											<DeleteIcon />
										</IconButton>
									</TableCell>
								</TableRow>
							);
						})}
					</TableBody>
				</Table>
			</TableContainer>
		</Box>
	);
};

export default QuantityTable;
